/**
 * Klasse ARKO_ANALYSE_FRESH_WINDOW.
 * Zustand, den die Oberfläche als offen liest, Glocken-Zeile und Helligkeit.
 * Kein Akteninhalt in der Glocke. Keine neue Ablage.
 */

export const ANALYSIS_LIGHT_SURFACE = '#f3efe8';
export const ANALYSIS_LIGHT_TEXT = '#1c1915';
export const ANALYSIS_LIGHT_ACCENT = '#5b4678';

export type AnalysisWindowColors = {
  surface: typeof ANALYSIS_LIGHT_SURFACE;
  text: typeof ANALYSIS_LIGHT_TEXT;
  accent: typeof ANALYSIS_LIGHT_ACCENT;
};

/** Hell liefert die Stein-Fläche. Dunkel bleibt beim bestehenden Fenster, ohne Aufhellen. */
export function analysisWindowColors(appearance: 'light' | 'dark'): AnalysisWindowColors | null {
  if (appearance === 'light') {
    return {
      surface: ANALYSIS_LIGHT_SURFACE,
      text: ANALYSIS_LIGHT_TEXT,
      accent: ANALYSIS_LIGHT_ACCENT,
    };
  }
  return null;
}

/** Nach einem echten Start liest die Oberfläche diese Id als offenes Fenster. */
export function analysisOpenJobIdOnStart(started: boolean, requestId: string): string | null {
  const id = requestId.trim();
  if (!started || !id) return null;
  return id;
}

export type AnalysisBellStatus = 'running' | 'done';

function shortAnalysisName(name: string, max = 48): string {
  const trimmed = name.trim() || 'Dokument';
  return trimmed.length > max ? `${trimmed.slice(0, max - 1)}…` : trimmed;
}

export function analysisBellStateLabel(status: AnalysisBellStatus): 'läuft' | 'fertig' {
  return status === 'running' ? 'läuft' : 'fertig';
}

/** Nur Dateiname und Zustand. Der Aufrufer darf keinen Lauftext anhängen. */
export function analysisBellLine(documentName: string, status: AnalysisBellStatus): string {
  return `${shortAnalysisName(documentName)} · ${analysisBellStateLabel(status)}`;
}

export type AnalysisBellEntry = {
  requestId: string;
  line: string;
};

export function analysisBellEntries(
  jobs: ReadonlyArray<{ request_id: string; documentName: string; status: string }>,
): AnalysisBellEntry[] {
  const out: AnalysisBellEntry[] = [];
  for (const job of jobs) {
    if (job.status !== 'running' && job.status !== 'done') continue;
    const requestId = job.request_id.trim();
    if (!requestId) continue;
    out.push({
      requestId,
      line: analysisBellLine(job.documentName, job.status),
    });
  }
  return out;
}
